// Calling codes and national-number lengths for the countries the store sells to.
export const DIAL_CODE_BY_COUNTRY = {
  US: '+1', MX: '+52', CO: '+57', GT: '+502', HN: '+504', SV: '+503', NI: '+505', CR: '+506', PA: '+507',
  DO: '+1', VE: '+58', EC: '+593', PE: '+51', BO: '+591', BR: '+55', PY: '+595', CL: '+56', AR: '+54', UY: '+598',
  ES: '+34', GB: '+44', FR: '+33', DE: '+49', IT: '+39',
};

// One entry per dial code: allowed digit counts and a representative region (for its display name/flag).
export const PHONE_RULES = {
  '+1': { min: 10, max: 10, region: 'US' },
  '+52': { min: 10, max: 10, region: 'MX' },
  '+57': { min: 10, max: 10, region: 'CO' },
  '+502': { min: 8, max: 8, region: 'GT' },
  '+504': { min: 8, max: 8, region: 'HN' },
  '+503': { min: 8, max: 8, region: 'SV' },
  '+505': { min: 8, max: 8, region: 'NI' },
  '+506': { min: 8, max: 8, region: 'CR' },
  '+507': { min: 7, max: 8, region: 'PA' },
  '+58': { min: 10, max: 10, region: 'VE' },
  '+593': { min: 9, max: 9, region: 'EC' },
  '+51': { min: 9, max: 9, region: 'PE' },
  '+591': { min: 8, max: 8, region: 'BO' },
  '+55': { min: 10, max: 11, region: 'BR' },
  '+595': { min: 9, max: 9, region: 'PY' },
  '+56': { min: 9, max: 9, region: 'CL' },
  '+54': { min: 10, max: 10, region: 'AR' },
  '+598': { min: 8, max: 9, region: 'UY' },
  '+34': { min: 9, max: 9, region: 'ES' },
  '+44': { min: 10, max: 10, region: 'GB' },
  '+33': { min: 9, max: 9, region: 'FR' },
  '+49': { min: 10, max: 11, region: 'DE' },
  '+39': { min: 9, max: 10, region: 'IT' },
};

export const flagEmoji = (region) =>
  String.fromCodePoint(...region.toUpperCase().split('').map((c) => 127397 + c.charCodeAt()));
